import { useQuery } from "@apollo/client";



const useQueryPackages = (query) => {

  const { loading, error, data } = useQuery(query, {
    variables: {
      first: 20,
      page: 1
    },
  });


  return {
    loadingQuery: loading,
    errorQuery: error,
    dataQuery: data && data.packages.data,
  };
}

export default useQueryPackages;
